import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { eur, num } from "@/lib/api";

const itDate = (iso) => (iso ? new Date(iso).toLocaleDateString("it-IT") : "—");

export default function RecallPreventiviDialog({ open, onOpenChange, items = [] }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl" data-testid="recall-preventivi-dialog">
        <DialogHeader>
          <DialogTitle>Recall preventivi ({items.length})</DialogTitle>
          <DialogDescription>Preventivi ancora aperti (non confermati) da ricontattare, emessi da 7–120 giorni.</DialogDescription>
        </DialogHeader>
        <div className="max-h-[60vh] overflow-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Data</TableHead>
                <TableHead>Cliente</TableHead>
                <TableHead>Stato</TableHead>
                <TableHead className="text-right">Valore</TableHead>
                <TableHead className="text-right">kW</TableHead>
                <TableHead className="text-right">Giorni</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {items.length === 0 && <TableRow><TableCell colSpan={6} className="py-8 text-center text-muted-foreground">Nessun preventivo da ricontattare.</TableCell></TableRow>}
              {items.map((q) => (
                <TableRow key={q.id} data-testid={`recall-row-${q.id}`}>
                  <TableCell className="text-sm">{itDate(q.date)}</TableCell>
                  <TableCell className="text-sm font-semibold">
                    {q.partner_id ? <Link to={`/partners/${q.partner_id}`} className="hover:text-primary hover:underline">{q.partner_name}</Link> : (q.partner_name || "—")}
                    {q.agency_name ? <span className="block text-[11px] font-normal text-muted-foreground">{q.agency_name}</span> : null}
                  </TableCell>
                  <TableCell className="text-sm">{q.stato}</TableCell>
                  <TableCell className="text-right font-mono text-sm">{eur(q.importo_eur)}</TableCell>
                  <TableCell className="text-right font-mono text-sm">{num(q.kwp)}</TableCell>
                  <TableCell className="text-right font-mono text-sm">{q.giorni}gg</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </DialogContent>
    </Dialog>
  );
}
